/**
 * Genera un identificador único razonablemente colision-free.
 *
 * Usa crypto.randomUUID cuando esté disponible (navegadores modernos
 * y Node ≥ 19) y cae a un UUIDv4 basado en crypto.getRandomValues.
 * El fallback final (Math.random) solo se da en entornos sin crypto.
 */
export function createId(): string {
  const cryptoObj = globalThis.crypto
  if (cryptoObj?.randomUUID) return cryptoObj.randomUUID()

  if (cryptoObj?.getRandomValues) {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16))
    // Set version (4) y variant (10xx).
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
      .slice(6, 8)
      .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
  }

  // Fallback degenerado; no debería alcanzarse en PWA modernas.
  return `id-${Date.now()}-${Math.random().toString(16).slice(2)}`
}
